import { getTenantContext, type TenantContext as TenantContextType } from '@duke-hq/libctx';
import { useMemo, createContext, useContext } from 'react';

import type { AdminTenantContextSettings } from '@duke-hq/app-admin-server/tenantContext';

export const TenantContext =
  createContext(getTenantContext<AdminTenantContextSettings, string[]>());

export function TenantContextProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => getTenantContext<AdminTenantContextSettings, string[]>(), []);
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

// Example usage:
// ```tsx
// const tenantCtx = useTenantContext();
//
// // Check if the tenant uses the new referral process
// if (tenantCtx.settings.uses_new_referral_process) {
//   // Show the new referral process
// }
// ```
//
// For permission checks, use `useCheckPermission` from `./hooks/useCheckPermission`
// instead — it seeds from `tenantCtx.permissions` (available on initial render) and
// then live-updates from the `me` tRPC query so it stays in sync without a reload.
export function useTenantContext():
  | TenantContextType<AdminTenantContextSettings, string[]>
  | undefined {
  return useContext(TenantContext);
}
